import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { CartIcon } from "@/shared/icons";
import Button from "@/shared/ui/button/Button";

type Props = {
  count: number;
  isCart: boolean;
  setIsCart: (value: boolean) => void;
};

export default function ShopCartButton({ count, isCart, setIsCart }: Props) {
  const { t } = useTranslation("shop");

  return (
    <Button
      onClick={() => setIsCart(true)}
      className={clsx(
        "justify-between gap-2.5 h-11 py-[0.875rem] pl-3.5 pr-[0.69rem] font-bold rounded-xl bg-accent-muted/20 hover:brightness-110",
        !count || isCart ? "pointer-events-none" : "pointer-events-auto",
      )}
      variant="solid"
    >
      <div className="flex items-center gap-2.5">
        <CartIcon className="size-4.5 text-accent-solid" />
        <p className="leading-none">{t("cart.cart")}</p>
      </div>
      {count > 0 && (
        <p className="px-1.5 py-2 leading-none rounded-lg bg-accent-solid/20">{count}</p>
      )}
    </Button>
  );
}
